export namespace SigningTemplateStatusConstants {
  export const SIGNED = 'Signed';
  export const DECLINED = 'Declined';
  export const NOT_SIGNED = 'Not signed';
  export const REJECTED = 'Rejected';
  export const APPROVED = 'Approved';
  export const MISSING = 'Missing';
}
